import { Checkbox, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export const CustomCheckbox = styled(Checkbox)({
  color: "#1976d2",
  "&.Mui-checked": { color: "#1976d2" },
  "&.Mui-checked svg": {
    backgroundColor: "#1976d2",
    borderRadius: "0px",
    width: "24px",
    height: "24px",
    color: "#FFF !important",
  },
});

export const CustomCheckIcon = () => (
  <div
    style={{
      width: 24,
      height: 24,
      backgroundColor: "#1976d2",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CheckIcon style={{ color: "white", fontSize: 18 }} />
  </div>
);